<div class="task-compact-card">
  <div class="task-compact-card__header">
    <h4 class="task-compact-card__title">{{ task.title }}</h4>
    <span [ngClass]="statusClass" class="task-compact-card__status">{{ statusLabel }}</span>
  </div>

  <div class="task-compact-card__meta">
    <span class="task-compact-card__meta-item">
      <app-icon [cssStyle]="{ 'margin-top': '1px' }" [planeIcon]="true" color="var(--slate-gray)" iconName="calendar" size="14px"></app-icon>
      {{ task?.date | date: 'dd.MM.yyyy' : 'UTC' }}
    </span>

    @if (task.subtaskCount) {
      <span class="task-compact-card__meta-item">
        <app-icon [cssStyle]="{ 'margin-top': '1px' }" [planeIcon]="true" color="var(--slate-gray)" iconName="sub-task" size="14px"></app-icon>
        {{ task.subtaskCompletedCount }}/{{ task.subtaskCount }}
      </span>
    }
  </div>
</div>
